export default __webpack_public_path__ + "assets/map_icon.49373ab0.svg";